import { LazyLoadComponent } from '@src/components';
import { lazy } from 'react';

const OrderResultPage = lazy(() =>
  import('@src/pages/Dashboard').then((module) => ({
    default: module.OrderPaymentResultPage,
  }))
);

export function OrderResultContainer() {
  return <LazyLoadComponent Component={<OrderResultPage />} />;
}
